import { useHasTrackingOptedOut } from './useHasTrackingOptedOut';
import { useOptOutTracking } from './useOptOutTracking';

export const useTrackingOptOut = () =>
  [useHasTrackingOptedOut(), useOptOutTracking()] as const;
